module.exports = __webpack_public_path__ + "img/imagen4.1c24bb96.png";